export enum DigitalRenewalOptions {
    RENEWAL = 'RENEWAL',
    REFINANCE = 'REFINANCE',
    PAYMENT = 'PAYMENT',
    RETURN_OF_THE_CAR = 'RETURN_OF_THE_CAR',
    MORE_INFO = 'MORE_INFO',
    EXTEND = 'EXTEND',
    JOINT_CONTRACT = 'JOINT_CONTRACT',
    CONFIRMATION = 'CONFIRMATION',
}
